import { UserSearchIcon, BriefcaseIcon, TargetIcon, HandshakeIcon } from 'lucide-react';

export const services = [
  {
    title: 'Executive Search',
    description:
      'Research-led search and confidential outreach for board, C-suite, and senior leadership appointments.',
    detail:
      'For appointments where the right individual is rarely actively looking. We define the brief with you, map the relevant talent market, and approach potential candidates directly and confidentially.',
    suitedTo: [
      'Board and C-suite appointments',
      'Senior leadership roles',
      'Confidential or sensitive searches',
    ],
    icon: UserSearchIcon,
  },
  {
    title: 'Senior & Executive Recruitment',
    description:
      'Recruitment for senior management and specialist roles where depth of experience and organizational fit matter most.',
    detail:
      'For senior management and specialist positions, combining targeted outreach with careful assessment of experience, motivation, and organizational fit.',
    suitedTo: [
      'Senior management roles',
      'Specialist and technical leadership',
      'Roles requiring specific sector experience',
    ],
    icon: BriefcaseIcon,
  },
  {
    title: 'Talent Sourcing',
    description:
      'Targeted talent-market research and candidate identification aligned with clearly defined role requirements.',
    detail:
      'Research-led identification of relevant professionals against a defined brief, giving your internal team a focused pool of potential candidates to engage.',
    suitedTo: [
      'Supporting in-house talent teams',
      'Market mapping for a specific role',
      'Hard-to-find skill sets',
    ],
    icon: TargetIcon,
  },
  {
    title: 'Recruitment Support',
    description:
      'Structured support with candidate discovery, initial screening, shortlisting, and introductions to your hiring team.',
    detail:
      'Hands-on support at the stages where you need it, from candidate discovery and initial screening to shortlisting and coordinating introductions.',
    suitedTo: [
      'Teams with limited recruitment capacity',
      'Several concurrent hires',
      'Shortlist preparation',
    ],
    icon: HandshakeIcon,
  },
];
